import {
  Badge,
  Box,
  Button,
  Card,
  Divider,
  Group,
  Image,
  rem,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { IconPointFilled } from "@tabler/icons-react";
import { AccessChecker } from "components/auth/AccessChecker";
import { AccessLimited } from "components/auth/AccessLimited/accessLimited";
import { useNavigate } from "react-router-dom";
import { RUBLE_SIGN } from "shared/const/common";
import { PROJECT_STATUSES } from "shared/const/projects";
import { formatLargeNumber } from "shared/helpers/formatLargeNumber";
import { DEFAULT_GRADIENT } from "shared/hooks/useGradient";
import { Project } from "shared/types/projects";

// const favoriteData = [
//   {
//     label: "Добавить в избранное",
//     color: "dark.0",
//     icon: <IconStar />,
//   },
//   {
//     label: "Убрать из избранного",
//     color: "gold.4",
//     icon: <IconStarFilled />,
//   },
// ];

export const ProjectCard = ({
  badge,
  categories,
  description,
  name,
  logo,
  status,
  id,
  images,
  activeRound,
  investors,
}: Project) => {
  const navigate = useNavigate();
  const projectPath = `/projects/${id}/about`;

  const handleNavigate = () => navigate(projectPath);

  return (
    <Card padding="lg" bg={"gray.0"} pb={-25} maw={400}>
      <Card.Section>
        <Image src={images[0]} h={200} />
      </Card.Section>
      <Stack mt={20} mb={20} gap={"sm"}>
        <Group gap={5}>
          <Badge
            bg={PROJECT_STATUSES[status].color}
            rightSection={status === "fundraising" && <IconPointFilled style={{ color: "red" }} />}
          >
            {PROJECT_STATUSES[status].label}
          </Badge>
        </Group>
        <Title fw={500} size={20} order={6}>
          {name}
        </Title>
        {!!activeRound.raised && (
          <Box>
            <Text size={rem(12)}>Уже собрано</Text>
            <Text pt={5} fw={600} variant={"gradient"} size={rem(20)} gradient={DEFAULT_GRADIENT}>
              {formatLargeNumber(activeRound.raised)} {RUBLE_SIGN}
            </Text>
          </Box>
        )}
        <Box>
          <Box style={{ display: "flex", alignItems: "center" }} mb={8}>
            <Text
              pr={5}
              fw={400}
              variant={"gradient"}
              size={rem(16)}
              lh={rem(24)}
              gradient={DEFAULT_GRADIENT}
            >
              Уже собрано:
            </Text>
            <AccessChecker rejectChildren={<AccessLimited />}>
              <Text fw={600} size={rem(16)} lh={rem(24)} c={"layout.4"}>
                5 908 480 {RUBLE_SIGN}
              </Text>
            </AccessChecker>
          </Box>
          <Box mb={16}>
            <Divider color={"gray.1"} size={"xs"} />
            <Group pt={8} pb={8} gap={5}>
              <Text fw={400} size={rem(14)} lh={rem(20)} c={"layout.4"}>
                Дата закрытия сбора:
              </Text>
              <AccessChecker rejectChildren={<AccessLimited />}>
                <Text fw={400} size={rem(14)} lh={rem(20)} c={"layout.4"}>
                  23 декабря 2023
                </Text>
              </AccessChecker>
            </Group>
            <Divider color={"gray.1"} size={"xs"} />
            <Group pt={8} pb={8} gap={5}>
              <Text fw={400} size={rem(14)} lh={rem(20)} c={"layout.4"}>
                Кол-во инвесторов:
              </Text>
              <AccessChecker rejectChildren={<AccessLimited />}>
                <Text fw={400} size={rem(14)} lh={rem(20)} c={"layout.4"}>
                  123
                </Text>
              </AccessChecker>
            </Group>
            <Divider color={"gray.1"} size={"xs"} />
          </Box>
        </Box>
        <Button bg={"green.2"} onClick={handleNavigate}>
          Подробнее
        </Button>
      </Stack>
    </Card>
  );
};
